import { Component } from 'react'
import PropTypes from 'prop-types'
import uniqBy from 'lodash/uniqBy'

import { expertApi } from '@atheneum/api'

class GetContactInfo extends Component {
  static propTypes = {
    expert: PropTypes.object,
    staticData: PropTypes.object,
    onContactInfoNotFound: PropTypes.func,
    onError: PropTypes.func,
    children: PropTypes.func
  }

  state = {
    loading: true,
    emailAddresses: [],
    phoneNumbers: []
  }

  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    await this.getContactInfo(this.props.expert)
  }

  getContactInfo = async expert => {
    const { onContactInfoNotFound, onError } = this.props
    const { experiences } = expert

    try {
      let emailAddresses = []
      let phoneNumbers = []

      const companies = uniqBy(experiences, ({ company }) => company.name)
        .filter(({ current }) => current)
        .map(({ company }) => company.name)

      if (companies.length) {
        const response = await expertApi.getContactInfo({ ...expert, companies })

        phoneNumbers = response.phoneNumbers
        emailAddresses = response.emailAddresses
      }

      if (
        !phoneNumbers.length &&
        !emailAddresses.length &&
        typeof onContactInfoNotFound === 'function'
      ) {
        return onContactInfoNotFound(expert)
      }

      this.setState({
        loading: false,
        phoneNumbers,
        emailAddresses
      })
    } catch (error) {
      onError(error)
    }
  }

  phoneToString = phone => {
    const { phoneTypes } = this.props.staticData.names
    const { phoneNum, phoneTypeId, company } = phone

    const parts = [phoneNum]

    const phoneType = phoneTypes[phoneTypeId]

    if (phoneType) parts.push(phoneType)
    if (company) parts.push(company)

    return parts.join(' - ')
  }

  emailToString = emailAddress => {
    const { email, company } = emailAddress

    return `${email}${company ? ' - ' + company : ''}`
  }

  render() {
    const { phoneToString, emailToString } = this

    return this.props.children({
      ...this.state,
      phoneToString,
      emailToString
    })
  }
}

export default GetContactInfo
